// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".w200[data-v-7d2f116c]{position:relative;width:200px;min-width:200px}.edit-btn[data-v-7d2f116c]{top:0}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/manufactures/components/CheckUnitsDialog.vue"],"names":[],"mappings":"AACA,uBACC,iBAAA,CACA,WAAA,CACA,eAAA,CAED,2BACC,KAAA","file":"CheckUnitsDialog.vue","sourcesContent":["\n.w200 {\n\tposition: relative;\n\twidth: 200px;\n\tmin-width: 200px;\n}\n.edit-btn {\n\ttop: 0;\n}\n"]}]);
// Exports
module.exports = exports;
